import { gql } from '@apollo/client';

const query = gql`
  query searchSeoList($params: JSONObject) {
    searchSeoList(params: $params)
  }
`;

module.exports = query;
